var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v(" Instancias ")]),_c('v-divider'),_c('ApplicationInstanceFilterViewComponent',{ref:"Grid",attrs:{"fnNew":_vm.$_new,"fnEdit":_vm.$_edit,"fnDelete":_vm.$_delete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }